var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function fileOrBlobToArrBuffer(file) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.readAsArrayBuffer(file);
    });
}
export function fileToArrBuffer(file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fileOrBlobToArrBuffer(file)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function blobToArrBuffer(blob) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fileOrBlobToArrBuffer(blob)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function fileToUrl(file) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.readAsDataURL(file);
    });
}
export function urlToImg(url) {
    return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
            resolve(img);
        };
        img.src = url;
    });
}
export function urlToBlob(dataURI) {
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
    }
    else {
        byteString = unescape(dataURI.split(',')[1]);
    }
    // separate out the mime component
    var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}
export function urlToArrayBuffer(dataURI) {
    var blob = urlToBlob(dataURI);
    return fileOrBlobToArrBuffer(blob);
}
export function fileToImg(file) {
    return __awaiter(this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fileToUrl(file)];
                case 1:
                    url = _a.sent();
                    return [4 /*yield*/, urlToImg(url)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function calcRectSize(originalW, originalH, maxDimension) {
    var scale = Math.min(1, maxDimension / (originalW > originalH ? originalW : originalH));
    return {
        width: Math.floor(originalW * scale),
        height: Math.floor(originalH * scale),
    };
}
export function compressImageToUrl(img, fileType, width, height) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (ctx === null) {
        return;
    }
    canvas.width = width;
    canvas.height = height;
    ctx.save();
    ctx.drawImage(img, 0, 0, width, height);
    ctx.restore();
    // encode image to data-uri with base64 version of compressed image
    return canvas.toDataURL(fileType, 0.5);
}
export function promptForMultipleFiles(accept, multiple) {
    if (accept === void 0) { accept = null; }
    if (multiple === void 0) { multiple = true; }
    return new Promise(function (resolve) {
        var input = document.createElement('input');
        input.type = 'file';
        if (accept) {
            input.accept = accept;
        }
        if (multiple) {
            input.setAttribute('multiple', 'multiple');
        }
        input.onchange = function (e) {
            resolve(e.target.files);
        };
        input.click();
    });
}
export function promptForSingleFile(accept) {
    if (accept === void 0) { accept = null; }
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, promptForMultipleFiles(accept, false)];
                case 1:
                    files = _a.sent();
                    if (!files || !files.length) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, files[0]];
            }
        });
    });
}
export function uploadToS3(uploadUrl, arrBuffer, abortController) {
    if (abortController === void 0) { abortController = null; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // @ts-ignore
                return [4 /*yield*/, fetch(uploadUrl, {
                        method: 'PUT',
                        mode: 'cors',
                        credentials: 'omit',
                        headers: {
                            'content-type': 'application/octet-stream',
                            'sec-fetch-mode': 'cors',
                        },
                        signal: abortController ? abortController.signal : null,
                        body: arrBuffer,
                    })];
                case 1:
                    // @ts-ignore
                    _a.sent();
                    return [2 /*return*/, uploadUrl.split('?')[0]];
            }
        });
    });
}
//# sourceMappingURL=file.helper.js.map